





























import Vue from 'vue';
import dropbox from '../assets/apps/dropbox.svg';
import github from '../assets/apps/github.png';
import slack from '../assets/apps/slack.png';
import zeplin from '../assets/apps/zeplin.png';

export default Vue.extend({
  data() {
    return {
      dropbox,
      github,
      slack,
      zeplin
    };
  }
});
